import {
  buildGenreCheckboxOptions,
  updateGenreCheckboxOptionsByValue,
  updateGenreCheckboxOptionsWhenSubGenreCheckedChange,
  updateGenreCheckboxOptionsWhenGenreCheckedChange,
  updateGenreCheckboxOptionsWhenSubGenreAllCheckedChange,
  updateGenreCheckboxOptionsWhenSubGenreBatchCheckedChange,
  updateGenreCheckboxOptionsWhenGenreAllCheckedChange,
  updateGenreCheckboxOptionsWhenGenreBatchCheckedChange,
  updateGenreCheckboxOptionsWhenGenreRelationChange,
  updateGenreCheckboxOptionsWhenGenreShortcuts,
  updateGenreCheckboxOptionsWhenGenreDeleteItem,
  updateGenreCheckboxOptionsWhenGenreDeleteBatch,
  updateGenreCheckboxOptionsWhenCascadeAllCheckedChange,
  updateGenreCheckboxOptionsWhenCascadeBatchCheckedChange,
  updateGenreCheckboxOptionsWhenCascadeDeleteItem,
  updateGenreCheckboxOptionsWhenCascadeShortcuts,
  updateGenreCheckboxOptionsWhenCascadeCheckedChangeByFilter,
} from '@intelligence/components/GenreSelect/reducers/utils';

import type { IGenresReducerState, IGenresReducerAction } from '@intelligence/components/GenreSelect/reducers/types';

export const GenresReducer: React.Reducer<IGenresReducerState, IGenresReducerAction> = (state, action) => {
  switch (action?.type) {
    // 初始化
    case 'initial': {
      return { ...state, ...buildGenreCheckboxOptions(action?.payload) };
    }
    // 根据组件外部传入value更新
    case 'update': {
      return { ...state, ...updateGenreCheckboxOptionsByValue(state, action?.payload) };
    }
    // 勾选、取消勾选副品类时更新
    case 'subGenreCheckedChange': {
      return { ...state, ...updateGenreCheckboxOptionsWhenSubGenreCheckedChange(state, action?.payload) };
    }
    // 勾选、取消勾选主品类时更新
    case 'genreCheckedChange': {
      return { ...state, ...updateGenreCheckboxOptionsWhenGenreCheckedChange(state, action?.payload) };
    }
    // 全选、取消全选副品类时更新
    case 'subGenreAllCheckedChange': {
      return { ...state, ...updateGenreCheckboxOptionsWhenSubGenreAllCheckedChange(state, action?.payload) };
    }
    // 批量勾选、批量取消勾选副品类时更新
    case 'subGenreBatchCheckedChange': {
      return { ...state, ...updateGenreCheckboxOptionsWhenSubGenreBatchCheckedChange(state, action?.payload) };
    }
    // 全选、取消全选主品类时更新
    case 'genreAllCheckedChange': {
      return { ...state, ...updateGenreCheckboxOptionsWhenGenreAllCheckedChange(state, action?.payload) };
    }
    // 批量勾选、批量取消勾选主品类时更新
    case 'genreBatchCheckedChange': {
      return { ...state, ...updateGenreCheckboxOptionsWhenGenreBatchCheckedChange(state, action?.payload) };
    }
    // 修改主品类relation时更新
    case 'genreRelationChange': {
      return { ...state, ...updateGenreCheckboxOptionsWhenGenreRelationChange(state, action?.payload) };
    }
    // 点击快捷勾选按钮时更新
    case 'genreShortcuts': {
      return { ...state, ...updateGenreCheckboxOptionsWhenGenreShortcuts(state, action?.payload) };
    }
    // 单个删除已勾选主品类时更新
    case 'genreDeleteItem': {
      return { ...state, ...updateGenreCheckboxOptionsWhenGenreDeleteItem(state, action?.payload) };
    }
    // 删除全部已勾选品类时
    case 'genreDeleteBatch': {
      return { ...state, ...updateGenreCheckboxOptionsWhenGenreDeleteBatch(state, action?.payload) };
    }
    // App Magic 级联品类全选/取消全选
    case 'cascadeAllCheckedChange': {
      return { ...state, ...updateGenreCheckboxOptionsWhenCascadeAllCheckedChange(state, action?.payload) };
    }
    // App Magic 级联品类搜索状态下批量勾选/取消勾选
    case 'cascadeBatchCheckedChange': {
      return { ...state, ...updateGenreCheckboxOptionsWhenCascadeBatchCheckedChange(state, action?.payload) };
    }
    // App Magic 级联品类精准删除（点击tag时根据路径精准取消勾选）
    case 'cascadeDeleteItem': {
      return { ...state, ...updateGenreCheckboxOptionsWhenCascadeDeleteItem(state, action?.payload) };
    }
    // App Magic 级联快捷勾选
    case 'cascadeShortcuts': {
      return {
        ...state,
        ...updateGenreCheckboxOptionsWhenCascadeShortcuts(state, action?.payload),
      };
    }
    // App Magic 级联品类勾选/取消勾选（搜索模式仅勾选匹配路径，非搜索模式勾选全部子路径）
    case 'cascadeCheckedChangeByFilter': {
      return { ...state, ...updateGenreCheckboxOptionsWhenCascadeCheckedChangeByFilter(state, action?.payload) };
    }
    default: {
      return state;
    }
  }
};
